import { Component, OnInit } from '@angular/core';
import { SiteConfigurationService } from '../../common/site-configuration.service'; 

@Component({
  selector: 'tn-home-desc',
  templateUrl: '../../themes/default/html/tnhomedesc.component.html',
  styleUrls: ['../../themes/default/css/tnhomedesc.component.scss']
})

export class TnhomedescComponent {

  Description: any;
  _mySettings: any;

  constructor(private mySettings: SiteConfigurationService) { 
      
    this._mySettings = mySettings.getFullConfig();
    this.Description = this._mySettings.e400.site.homeDescription.it;
      
   }

}
 


// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnhomedesc/tnhomedesc.component.ts